import { Flex, Typography } from "antd";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { IActivityLog, ITreatment2 } from "../../../../util/varibles/interface";
import SiteDisease from "../../../Operation/FishDisease/SiteDisease";
import TaskView from "../../../Operation/Task/TaskView";
import WeatherSection from "../WeatherSection";

export default function ArrivedStep({ log }: { log: IActivityLog }) {
    const [op] = useTrackingOp(state => state.op?.operation as ITreatment2);
    if (!op) return <></>;

    const { real_start_time, arrive_time } = log;
    const time = arrive_time || real_start_time;
    return <div className="w-full">
        <Flex gap={6}>
            <Typography.Text type="secondary">Arrived at site: </Typography.Text>
            <Typography.Text>{time ? datetime(time).format("HH:mm, DD/MM") : '--'}</Typography.Text>
        </Flex>
        {(op?.diseases && op?.diseases.length > 0) && <SiteDisease diseases={op?.diseases} />}
        <div className="mt-[5px]">
            <TaskView tasks={op.tasks} />
        </div>
        <div className="w-full flex flex-col mt-5 items-center">
            <Typography.Title level={4} className="!mb-0">Weather Info.</Typography.Title>
            <Typography.Text className="!mb-3 block">(The weather chart will be live updated following the operation time, duration)</Typography.Text>
            <WeatherSection />
        </div>
    </div>
}